import { render, staticRenderFns } from "./UpdateCallLogRelatedUserDataModal.vue?vue&type=template&id=9054ceb4&"
import script from "./UpdateCallLogRelatedUserDataModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCallLogRelatedUserDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports